import './index.css'
import React, { useEffect, useState } from 'react'
import { CircularProgress, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import { useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import {
  CATEGORIES,
  NOTES,
  RISK_REPORTS,
} from 'src/utils/constants/RiskReports'
import TopRisks from 'src/components/RiskReports/TopRisks/TopRisks'
import UpcomingRenewals from 'src/components/RiskReports/UpComingRenewals/UpcomingRenewals'
import RiskCategoriesDetails from 'src/components/RiskCategories/RiskCategoriesDetails'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import DownloadReports from 'src/components/RiskReports/RiskAnalysisDownloadReports/DownloadReports'
import Premium from 'src/components/RiskReports/Premium/Premium'
import PendingClaims from 'src/components/RiskReports/PendingClaims/PendingClaims'
import { FETCH_RISK_REPORT } from 'src/services/riskReportsService'
import {
  isCorporateAdmin,
  isCorporateCeo,
  isCorporatePOC,
} from 'src/utils/commonMethods'
import PremiumAndClaimsView from 'src/components/RiskReports/PremuimAndClaims/PremiumAndClaimsView'
import { getFinancialYears } from 'src/utils/commonMethods/financialYearMethods'
import { GET_LINKED_COMPANIES } from 'src/services/corporateService'
import LinkedCompanies from 'src/components/common/LinkedCompanies'

const RiskReports = () => {
  const classes = useStyles()
  const userInfo = useSelector((state) => state?.userInfo)
  const financialYearOptions = getFinancialYears()
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(
    financialYearOptions[0]?.value
  )
  const [riskReport, setRiskReport] = useState({})
  const [series, setSeries] = useState([
    {
      name: '',
      data: [0, 0, 0],
    },
  ])
  const [financialseries, setFinancialSeries] = useState([
    {
      name: '',
      data: [0, 0, 0],
    },
  ])
  let clientId = userInfo?.userInfo?.userData?.clientId
  const [ebClaimsGraphData, setEbClaimsGraphData] = useState([])
  const [nonEbClaimsGraphData, setNonEbClaimsGraphData] = useState([])
  const [childOptions, setChildOptions] = useState([])

  const computeClaimsChartValues = (claimsData) => {
    const claimsOutstanding = claimsData
      ?.map((item) => item?.claimsOutstanding)
      ?.reduce(function (sum, value) {
        return sum + value
      }, 0)
    const claimsPaid = claimsData
      ?.map((item) => item?.claimsPaid)
      ?.reduce(function (sum, value) {
        return sum + value
      }, 0)
    const totalClaims = claimsData
      ?.map((item) => item?.totalClaims)
      ?.reduce(function (sum, value) {
        return sum + value
      }, 0)
    const totalPremium = claimsData
      ?.map((item) => item?.totalPremium)
      ?.reduce(function (sum, value) {
        return sum + value
      }, 0)

    const chartData = [totalPremium, totalClaims, claimsPaid, claimsOutstanding]
    const roundedChartData = chartData?.map((item) =>
      item > 0 ? Number((item / RISK_REPORTS?.TO_LAKHS)?.toFixed(2)) : 0
    )

    setSeries([{ ...series, data: roundedChartData }])
  }

  const computeFinancialChartValues = (financialData) => {
    const claimsOutstanding = financialData
      ?.map((item) => item?.claimsOutstanding)
      ?.reduce(function (sum, value) {
        return sum + value
      }, 0)
    const claimsPaid = financialData
      ?.map((item) => item?.claimsPaid)
      ?.reduce(function (sum, value) {
        return sum + value
      }, 0)
    const totalClaims = financialData
      ?.map((item) => item?.totalClaims)
      ?.reduce(function (sum, value) {
        return sum + value
      }, 0)
    const totalPremium = financialData
      ?.map((item) => item?.totalPremium)
      ?.reduce(function (sum, value) {
        return sum + value
      }, 0)

    const chartData = [totalPremium, totalClaims, claimsPaid, claimsOutstanding]
    const roundedChartData = chartData?.map((item) =>
      item > 0 ? Number((item / RISK_REPORTS?.TO_LAKHS)?.toFixed(2)) : 0
    )

    setFinancialSeries([{ ...financialseries, data: roundedChartData }])
  }
  // const getEmployeeBenefitsClaimsData = (claimsGraphData) => {
  //   return [
  //     claimsGraphData?.employeeBenefits?.SETTLED,
  //     claimsGraphData?.employeeBenefits?.OUTSTANDING,
  //     claimsGraphData?.employeeBenefits?.PENDING,
  //     claimsGraphData?.employeeBenefits?.REJECTED,
  //   ]
  // }
  // const getNonEmployeeBenefitsClaimsData = (claimsGraphData) => {
  //   return [
  //     claimsGraphData?.nonEmployeeBenefits?.SETTLED,
  //     claimsGraphData?.nonEmployeeBenefits?.OUTSTANDING,
  //     claimsGraphData?.nonEmployeeBenefits?.PENDING,
  //     claimsGraphData?.nonEmployeeBenefits?.REJECTED,
  //   ]
  // } might be used in future development

  const { loading, error, data } = useQuery(
    FETCH_RISK_REPORT(clientId, selectedFinancialYear),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )

  const { data: linkedCompaniesData } = useQuery(GET_LINKED_COMPANIES(), {
    variables: {
      clientId:
        userInfo?.userInfo?.userData?.parentClientId ||
        userInfo?.userInfo?.userData?.clientId,
    },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const childCompaniesList =
    linkedCompaniesData?.getChildAndParentCompanyDetails
      ?.childCompanyDetailsList

  useEffect(() => {
    setChildOptions(childCompaniesList)
    // eslint-disable-next-line
  }, [linkedCompaniesData])

  useEffect(() => {
    if (data) {
      setRiskReport(data?.getRiskReport)
      const chartValues = get(
        data,
        'getRiskReport.riskInsurance.riskData.premiumClaimYearlyData',
        []
      )
      const financialChartValues = get(
        data,
        'getRiskReport.riskInsurance.riskData.financialYearlyClaimData',
        []
      )
      computeClaimsChartValues(chartValues === null ? [] : chartValues)
      computeFinancialChartValues(
        financialChartValues === null ? [] : financialChartValues
      )
      setEbClaimsGraphData(
        data?.getRiskReport?.riskInsurance?.riskData
          ?.financialYearClaimsGraphData?.employeeBenefits
      )
      setNonEbClaimsGraphData(
        data?.getRiskReport?.riskInsurance?.riskData
          ?.financialYearClaimsGraphData?.nonEmployeeBenefits
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if (loading)
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    )
  if (error) return <GraphQlErrors error={error} />

  const policyInsuranceTypeAggregate = get(
    riskReport,
    'policyInsuranceTypeAggregate',
    []
  )
  const claimStatusCounts = get(
    riskReport,
    'riskInsurance.riskData.claimStatusCounts',
    []
  )
  const claimStatusUpdatedOn = get(
    riskReport,
    'riskInsurance.riskData.claimStatusUpdatedOn',
    null
  )
  const claimsTypeData = get(
    riskReport,
    'riskInsurance.riskData.claimsTypeData',
    []
  )
  const premiumClaimYearlyData = get(
    riskReport,
    'riskInsurance.riskData.premiumClaimYearlyData',
    []
  )
  const financialPremiumClaimYearlyData = get(
    riskReport,
    'riskInsurance.riskData.financialYearlyClaimData',
    []
  )
  const topRisks = get(riskReport, 'riskInsurance.riskData.topRisks', [])
  const riskList = get(riskReport, 'riskInsurance.riskList', {})
  const policies = get(riskReport, 'riskInsurance.policies', [])
  const aggregatedPolicies = get(
    riskReport,
    'riskInsurance.aggregatedPolicies',
    []
  )
  const reportUrls = get(riskReport, 'riskInsurance.riskData.reportUrls', [])
  const downloadReportData = get(
    riskReport,
    'riskInsurance.riskData.groupedReports',
    {}
  )

  const handleReportsDownload = () => {
    if (reportUrls?.length === 0) return
    for (const url of reportUrls) {
      window.open(url, RISK_REPORTS?.LINK_BLANK)
    }
  }

  const BAR_CHART_HEIGHT = window.innerWidth < 1320 ? 285 : 340

  const showCompanyPoliciesButton = () => {
    const roles = userInfo?.userInfo?.userData?.roles
    return isCorporateCeo(roles) || isCorporateAdmin(roles)
  }

  const showMyPoliciesButton = () => {
    const roles = userInfo?.userInfo?.userData?.roles
    return isCorporateCeo(roles) || isCorporatePOC(roles)
  }

  // const handleChange = (event) => {
  //   const value = event.target.value
  //   setSelectedValue(value)
  // }

  return (
    <>
      <div className={classes.root}>
        <div className='riskReportIndex'>
          <Grid container spacing={3} alignItems='stretch'>
            <Grid item xs={12} sm={6} md={3}>
              <div className={classes.policyButtons}>
                {showMyPoliciesButton() ? (
                  <div className={classes.showMypolicyContainer}>
                    <Link
                      className={classes.link}
                      to={{
                        pathname: '/individual/dashboard/home',
                        state: { isCeoView: true },
                      }}
                    >
                      <Button className={classes.buttonUploadPersonal}>
                        My Policies
                      </Button>
                    </Link>
                  </div>
                ) : null}

                {showCompanyPoliciesButton() ? (
                  <div className={classes.showMypolicyContainer}>
                    <Link
                      className={classes.link}
                      to={'/individual/dashboard/company'}
                    >
                      <Button className={classes.buttonUploadPersonal}>
                        Company Policies
                      </Button>
                    </Link>
                  </div>
                ) : null}
                {/* {childOptions?.length > 0 && (
                  <FormControl fullWidth>
                    <Select
                      size='small'
                      value={selectedValue || ''}
                      onChange={handleChange}
                      displayEmpty
                    >
                      <MenuItem value=''>
                        <Typography
                          variant='body1'
                          fontWeight='bold'
                          // fontStyle='italic'
                        >
                          {userInfo?.userInfo?.userData?.parentClientId}
                        </Typography>
                      </MenuItem>
                      {childOptions?.map((option) => (
                        <MenuItem key={option.id} value={option.clientId}>
                          {option.userDetails.userName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )} */}
              </div>
              <LinkedCompanies childOptions={childOptions} />
              <DownloadReports
                title={RISK_REPORTS?.DOWNLOAD_REPORTS}
                desc={RISK_REPORTS?.DETAILED_RISK_ANALYSIS_REPORT_HELPER}
                text={RISK_REPORTS?.DOWNLOAD_REPORTS}
                handleClick={handleReportsDownload}
                downloadReportData={downloadReportData}
                disabled={!reportUrls}
              />
              <div className={classes.commonMargin}>
                <PremiumAndClaimsView
                  series={series}
                  financialSeries={financialseries}
                  categories={CATEGORIES}
                  data={premiumClaimYearlyData}
                  financialData={financialPremiumClaimYearlyData}
                  chartHeight={BAR_CHART_HEIGHT}
                  className={classes.commonMargin}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TopRisks data={topRisks} />
              <RiskCategoriesDetails data={riskList} />
              <div className={classes.commonMargin}>
                <UpcomingRenewals
                  data={policies}
                  aggregatedPolicies={aggregatedPolicies}
                  ClientId={clientId}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Premium data={policyInsuranceTypeAggregate} />
              <div className={classes.commonMargin}>
                <PendingClaims
                  claimCounts={claimStatusCounts}
                  claimsData={claimsTypeData}
                  date={claimStatusUpdatedOn}
                  type='generalForm'
                  employeeBenefitsData={ebClaimsGraphData}
                  nonEmployeeBenefitsData={nonEbClaimsGraphData}
                  financialYearOptions={financialYearOptions}
                  selectedFinancialYear={selectedFinancialYear}
                  setSelectedFinancialYear={setSelectedFinancialYear}
                />
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.note}>Note: {NOTES}</div>
          </Grid>
        </div>
      </div>
    </>
  )
}

export default RiskReports

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '30px',
    width: '100%',
    background: '#e5e5e5',
    boxSizing: 'border-box',
  },
  loadingContainer: {
    margin: 'auto',
  },
  showMypolicyContainer: {
    paddingBottom: '5px',
    width: '50%',
  },
  note: {
    width: '95%',
    fontSize: '13px',
    fontStyle: 'italic',
    color: '#333333',
    margin: '24px auto',
  },
  buttonUploadPersonal: {
    textTransform: 'unset !important',
    fontSize: '11px  !important',
    fontWeight: '600  !important',
    background: `${COLORS.DARK_PINK} !important`,
    color: `${COLORS.WHITE} !important`,
    margin: '0px !important',
    height: '24px !important',
    padding: '0px 10px !important',
    borderRadius: '6px !important',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: `${COLORS.DARK_PINK} !important`,
    },
    width: '100%',
  },
  policyButtons: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    width: '100%',
  },
  link: {
    textDecoration: 'None',
    color: COLORS.MEDIUM_BLUE,
  },
  commonMargin: {
    marginTop: '24px',
  },
  childsDropdownContainer: { width: '100%', margin: '10px 0px' },
  menuItemFormatting: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    border: '1px solid lightgrey !important',
  },
  iconStyles: {
    marginRight: '5px !important',
    boxSizing: 'border-box',
  },
})
